import styled from 'styled-components';

export const Container = styled.div`
	position: fixed;
	width: 100%;
	height: 100dvh;

	@supports (-webkit-touch-callout: none) {
		height: -webkit-fill-available;
	}

	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	z-index: 100;

	&::before {
		content: '';
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 100%;
		height: 100dvh;
		@supports (-webkit-touch-callout: none) {
			height: -webkit-fill-available;
		}
		opacity: 30%;
		background-color: ${({ theme }) => theme['black-primary']};
	}
`;

export const Wrapper = styled.div`
	width: 300px;
	padding: 24px;
	border-radius: 10px;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 16px;

	position: relative;
	z-index: 100;

	background-color: ${({ theme }) => theme['white-primary']};
`;

export const SingleInputFormPopupWrapper = styled.form`
	width: 300px;
	padding: 20px;
	padding-bottom: 30px;
	border-radius: 10px;

	display: flex;
	flex-direction: column;
	gap: 14px;

	position: relative;
	z-index: 100;

	background-color: ${({ theme }) => theme['white-primary']};
`;

export const Img = styled.img`
	width: calc(100% + 48px);
	margin-top: -24px;

	border-top-right-radius: 10px;
	border-top-left-radius: 10px;
`;
